import React, { useContext } from 'react';
import LanguageContext from '../LanguageContext';
import Menu from '../components/Menu';
import translations from '../utils/translation';

const Presentation = () => {
  const { language } = useContext(LanguageContext);
  const t = translations.presentation[language];

  const powerColors = {
    blancsSecs: ['#cce5b1', '#66a05b', '#00471f'],
    blancsLiquoreux: ['#ffcc00', '#e69900', '#cc6600'],
    rouges: ['#d8a3af', '#a04667', '#5a1f2d']
  };

  return (
    <div className="main-section">
      {/* Menu fixé en haut-gauche */}
      <Menu />

      {/* Titre centré */}
      <h1 className="wine-title">{t.title}</h1>

      {/* Réussite */}
      <h2 className="wine-subtitle" style={{ textAlign: 'left', marginTop: '2rem' }}>
        {t.success.title}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
        {t.success.levels.map((label, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
            <span
              style={{
                width: `${20 - i * 3.1}px`,
                height: `${20 - i * 3.1}px`,
                borderRadius: '50%',
                border: `${2 - i * 0.5}px solid #000`,
                flexShrink: 0
              }}
            />
            <span style={{ marginLeft: '0.75rem' }}>{label}</span>
          </div>
        ))}
      </div>

      {/* Évolution */}
      <h2 className="wine-subtitle" style={{ textAlign: 'left' }}>
        {t.evolution.title}
      </h2>
      <div style={{ display: 'grid', gap: '0.75rem', marginBottom: '2rem' }}>
        {t.evolution.levels.map((text, i) => (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: '24px 1fr',
              alignItems: 'center'
            }}
          >
            <span
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                background:
                  i === 0
                    ? 'conic-gradient(#999 0% 25%, transparent 25% 100%)'
                    : i === 1
                    ? 'conic-gradient(#666 0% 50%, transparent 50% 100%)'
                    : i === 2
                    ? 'conic-gradient(#444 0% 75%, transparent 75% 100%)'
                    : '#444',
                border: '1px solid #333'
              }}
            />
            <span>{text}</span>
          </div>
        ))}
      </div>

      {/* Puissance */}
      <h2 className="wine-subtitle" style={{ textAlign: 'left' }}>
        {t.power.title}
      </h2>
      <div className="wine-power-section">
        {['blancsSecs', 'blancsLiquoreux', 'rouges'].map((cat, idx) => (
          <div key={cat}>
            <h3 style={{ marginTop: idx === 0 ? 0 : '1rem' }}>
              {t.power[cat].title}
            </h3>
            {t.power[cat].levels.map((label, i) => (
              <div
                key={i}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '24px 1fr',
                  alignItems: 'center',
                  marginBottom: '0.5rem'
                }}
              >
                <span
                  style={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: powerColors[cat][i]
                  }}
                />
                <span>{label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Presentation;
